"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.prepareTransaction = void 0;
var invariant_1 = __importDefault(require("invariant"));
var gas_1 = require("./gas");
var gas_2 = require("./gas");
var logic_1 = require("./logic");
var transaction_1 = require("./transaction");
var modules_1 = require("./modules");
var account_1 = require("../../account");
var prepareTransaction = function (account, tx) { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo, _a, maxPriorityFeePerGas, maxFeePerGas, gasPrice, estimatedGasLimit, protoTransaction;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = tx.networkInfo;
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, gas_1.getNetworkInfo)(account.currency)];
            case 1:
                _a = (_b.sent());
                _b.label = 2;
            case 2:
                networkInfo = _a;
                if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                    maxPriorityFeePerGas = (0, gas_1.inferMaxPriorityFeePerGas)(tx, networkInfo);
                    maxFeePerGas = (0, gas_1.inferMaxFeePerGas)(tx, maxPriorityFeePerGas, networkInfo);
                    if (tx.maxFeePerGas !== maxFeePerGas ||
                        tx.maxPriorityFeePerGas !== maxPriorityFeePerGas ||
                        tx.networkInfo !== networkInfo) {
                        tx = __assign(__assign({}, tx), { networkInfo: networkInfo, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas });
                    }
                }
                else {
                    gasPrice = (0, gas_1.inferGasPrice)(tx, networkInfo);
                    if (tx.gasPrice !== gasPrice || tx.networkInfo !== networkInfo) {
                        tx = __assign(__assign({}, tx), { networkInfo: networkInfo, gasPrice: gasPrice });
                    }
                }
                if (!(0, logic_1.isEthereumAddress)(tx.recipient)) return [3 /*break*/, 4];
                protoTransaction = (function () {
                    try {
                        return (0, transaction_1.buildEthereumTx)(account, tx, account.operationsCount).tx;
                    }
                    catch (e) {
                        // fallback in case @ethereumjs/tx breaks on building a potentially partial transaction
                        var subAccount = tx.subAccountId
                            ? (0, account_1.findSubAccountById)(account, tx.subAccountId)
                            : null;
                        var recipient = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount"
                            ? subAccount.token.contractAddress
                            : tx.recipient;
                        return {
                            from: account.freshAddress,
                            to: recipient,
                            data: undefined,
                            value: tx.amount
                        };
                    }
                })();
                (0, invariant_1["default"])(protoTransaction.to, "ethereum transaction has no recipient");
                return [4 /*yield*/, (0, gas_2.estimateGasLimit)(account, 
                    // Those are the only elements from a transaction necessary to estimate the gas limit
                    {
                        from: account.freshAddress,
                        to: protoTransaction.to.toString(),
                        value: "0x" + ((0, logic_1.padHexString)(protoTransaction.value.toString(16)) || "00"),
                        data: protoTransaction.data
                            ? "0x".concat((0, logic_1.padHexString)(protoTransaction.data.toString("hex")))
                            : "0x"
                    })];
            case 3:
                estimatedGasLimit = _b.sent();
                _b.label = 4;
            case 4:
                if (!tx.estimatedGasLimit ||
                    (estimatedGasLimit && !estimatedGasLimit.eq(tx.estimatedGasLimit))) {
                    tx.estimatedGasLimit = estimatedGasLimit;
                }
                return [4 /*yield*/, (0, modules_1.prepareTransaction)(account, tx)];
            case 5:
                tx = _b.sent();
                return [2 /*return*/, tx];
        }
    });
}); };
exports.prepareTransaction = prepareTransaction;
exports["default"] = exports.prepareTransaction;
//# sourceMappingURL=prepareTransaction.js.map